import { Component, OnInit } from '@angular/core';
import { AuthService } from '@fapp/authentication';
import { RootMixin, UserAwareMixin } from '@fapp/mixins';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  standalone: false,
})
export class UserMenuComponent
  extends UserAwareMixin(RootMixin)
  implements OnInit
{
  luser: Observable<any>;
  constructor(private auth: AuthService) {
    super();
  }

  ngOnInit(): void {
    this.luser = this.currentUser.valueChanges.pipe(
      map((res: any) => res.data.currentUser)
    );
  }

  logout() {
    this.auth.logout();
  }
}
